import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import { ReactComponent as CloseIconRed } from "../../assests/icons/close_icon_red.svg";
import { ReactComponent as CautionIcon } from "../../assests/icons/caution_icon.svg";
import Box from "@mui/material/Box";
import { useDispatch, useSelector } from "react-redux";
import { dialogActions } from "../../store/reducers/dialog";
import { useNavigate } from "react-router-dom";
import CircularLoader from "../CircularLoader";
import { RequestDialogWrap } from "./Dialog.styles";

const RequestsDialog = ({
  dialogTitle,
  dialogContent,
  leftBtnVal,
  rightBtnVal,
  leftbuttonHandler = () => {},
  ...props
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [open, setOpen] = React.useState(true);
  const [loader, setLoader] = React.useState(false);
  const theme = useTheme();
  const dialogType = useSelector((state) => state.dialog.dialogType);

  // const handleClickOpen = () => {
  //   setOpen(true);
  // };

  const handleClose = () => {
    setOpen(false);
    dispatch(dialogActions.setIsDialogEnabled(false));
    dispatch(dialogActions.setDialogType(""));
    dispatch(dialogActions.setDataObj({}));
  };

  const handleLeftButtonClick = () => {
    leftbuttonHandler();
  };

  return (
    <Box>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
        maxWidth={false}
      >
        <RequestDialogWrap>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              width: "100%",
              paddingBottom: "0.2rem",
              borderBottom: "1px solid #c8c8c8",
            }}
          >
            <DialogTitle
              id="responsive-dialog-title"
              sx={{
                margin: "auto",
                padding: "0",
                fontSize: "2.5rem",
                color: "#cf2030",
              }}
            >
              {dialogTitle}
            </DialogTitle>
            <CloseIconRed onClick={handleClose} />
          </Box>
          <DialogContent>
            <DialogContentText sx={{ textAlign: "center", "@media only screen and (max-width: 750px)": {
                fontSize: "16px",
              }, }}>
              {dialogContent}
            </DialogContentText>
          </DialogContent>
          <DialogActions sx={{gap:".8rem", "@media only screen and (max-width: 750px)": {
            flexDirection: "column",
            rowGap: "2.5rem",
            width: "100%",
          }}}>
            <Button
              onClick={handleLeftButtonClick}
              sx={{
                padding: "0.5rem 2rem",
                border: "2px solid #cf2030",
                background: "#cf2030",
                color: "#f2f2f2",
                "&:hover": { background: "#cf2030" },
                "@media only screen and (max-width: 750px)": {
                  width:"100%"
                }
              }}
            >
              {leftBtnVal}
            </Button>
            <Button
              onClick={handleClose}
              sx={{
                marginLeft: "0rem !important",
                padding: "0.5rem 2rem",
                border: "2px solid #cf2030",
                color: "#cf2030",
                background: "#ffffff",
                "&:hover": { background: "#ffffff" },
                "@media only screen and (max-width: 750px)": {
                  marginLeft:"0 !important",
                  marginRight:"0 !important",
                  width:"100%"
                }
              }}
            >
              {rightBtnVal}
            </Button>
          </DialogActions>
        </RequestDialogWrap>
      </Dialog>
      {loader && <CircularLoader />}
    </Box>
  );
};

export default RequestsDialog;
